import React, { ChangeEvent, Component, useState } from "react";
import "./QBDItemSyncPriceGroupSelectionModal.scss";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import ISupplierModel from "../../../../models/ISupplierModel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import ICatalog from "../../../../models/ICatalog";
import IPrice_Group from "../../../../models/IPrice_Group";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    startFn: (priceGroupGuid?: string) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    priceGroups: IPrice_Group[];
};

export const QBDItemSyncPriceGroupSelectionModal: React.FC<Props> = (props) => {
    const [selectedPriceGroupGuid, setSelectedPriceGroupGuid] = useState<string>();
    const [dontUsePriceGroup, setDontUsePriceGroup] = useState<boolean>(false);

    const closeModal = () => {
        props.closeModalFn();
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        setSelectedPriceGroupGuid(value);
    };

    const startFn = () => {
        if (selectedPriceGroupGuid) {
            props.startFn(selectedPriceGroupGuid);
        } else if (dontUsePriceGroup) {
            props.startFn();
        }
    };

    const dontUsePriceGroupFn = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        setDontUsePriceGroup(value);
    };

    return (
        <div className={"QBDItemSyncPriceGroupSelectionModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-ballot-check"} title={"price_group_selection"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwLabel title={"price_group"} />
                    <div>
                        <OwSelectOption
                            name={"price_group_id"}
                            fn={handleChange}
                            valueProp={"guid"}
                            titleProp={"value"}
                            options={props.priceGroups}
                            isDisabled={dontUsePriceGroup}
                        />
                        <div className={"mt-2"}>
                            <OwCheckbox
                                label={"dont_use_price_group"}
                                name={"dontUsePriceGroup"}
                                fn={dontUsePriceGroupFn}
                                checked={dontUsePriceGroup}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                    </div>
                </div>
                <div className={"mt-2"}>
                    <OwButton title={"start"} fn={startFn} />
                </div>
            </div>
        </div>
    );
};
